/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_CloudInputs */

const en_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Storage`)
};

const fr_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage cloud`)
};

const de_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Speicher`)
};

const it_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione cloud`)
};

const ru_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облачное хранилище`)
};

const es_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento en la nube`)
};

const zh_cn2_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云存储`)
};

const ja_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウドストレージ`)
};

const hi_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घन संग्रहण`)
};

const pt_pt2_options_backup_destination_cloud = /** @type {(inputs: Options_Backup_Destination_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento em nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud Storage" |
*
* @param {Options_Backup_Destination_CloudInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_cloud = /** @type {((inputs?: Options_Backup_Destination_CloudInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_CloudInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_destination_cloud(inputs)
	if (locale === "de") return de_options_backup_destination_cloud(inputs)
	if (locale === "it") return it_options_backup_destination_cloud(inputs)
	if (locale === "ru") return ru_options_backup_destination_cloud(inputs)
	if (locale === "es") return es_options_backup_destination_cloud(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_destination_cloud(inputs)
	if (locale === "ja") return ja_options_backup_destination_cloud(inputs)
	if (locale === "hi") return hi_options_backup_destination_cloud(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_destination_cloud(inputs)
	return en_options_backup_destination_cloud(inputs)
});